import { match } from '../utilities/ResolutionHandler';
import BaseComponent from '../abstracts/BaseComponent';

export default class SearchComponent extends BaseComponent {
  get Messages() {
    return {
      [this.CUSTOM_MESSAGES.INPAGE_LAYER_EVENTS.close]: this.close
    };
  }

  get SELECTORS() {
    return {
      onfocus: '.js-on-focus',
      info: '.js-info',
      steps: '.js-steps-search',
      btn: '.js-action',
      input: 'input[name="searchQuery"]',
      wrap: '.js-wrap-search-type',
      searchLayer: '.js-in-page-layer'
    };
  }

  get CLASSES() {
    return {
      animate: 'animate',
      visible: 'visible',
      close: 'close'
    };
  }

  constructor(element) {
    super(element);
    this.handleFocus();
    this.handleBtnClick();
  }

  close() {
    const searchLayer = document.querySelector(this.SELECTORS.searchLayer);
    if (searchLayer.classList.contains('expanded')) {
      searchLayer.classList.remove('expanded');
    }
  }

  handleFocus() {
    const input = document.querySelector(this.SELECTORS.input);
    const info = document.querySelector(this.SELECTORS.info);
    const steps = document.querySelector(this.SELECTORS.steps);
    const wrap = document.querySelector(this.SELECTORS.wrap);
    const searchLayer = document.querySelector(this.SELECTORS.searchLayer);

    if (match('large', null) && searchLayer && !searchLayer.classList.contains('expanded')) {
      this.$on('click.search', (e) => {
        e.preventDefault();
        searchLayer.classList.add('expanded');
        wrap.classList.add(this.CLASSES.visible);
      }, searchLayer);
    }

    this.$on('focus.search', (e) => {
      if (info && steps) {
        if (match('large', null)) {
          searchLayer.classList.add('expanded');
          wrap.classList.add(this.CLASSES.visible);
        }
        steps.classList.remove(this.CLASSES.visible);
        this.timeout = setTimeout(() => {
          info.classList.add(this.CLASSES.visible);
        }, 300);
      }
    }, input);

    this.$on('blur.search', () => {
      if (info && steps) {
        info.classList.remove(this.CLASSES.visible);
        this.timeout = setTimeout(() => {
          steps.classList.add(this.CLASSES.visible);
        }, 300);
      }
    }, input);
  }

  handleBtnClick() {
    const btn = document.querySelector(this.SELECTORS.btn);
    const input = document.querySelector(this.SELECTORS.input);
    this.$on('click.search', () => {
      if (btn.classList.contains(this.CLASSES.close)) {
        btn.classList.remove(this.CLASSES.close);
        input.value = '';
        btn.type = 'submit';
        input.parentElement.classList.remove('floatl--active');
      }
    }, btn);
  }
}
